export default {
    install: (app, options) => {
        const script = document.createElement("script")
        script.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs"
        script.async = true

        script.onload = () => {
            const urlLang = window.location.pathname.replaceAll("/", "")

            // Only on FR, CT or TMP
            if (urlLang == "fr" || urlLang == "ct" || urlLang == "tmp") {
                window.voiceflow.chat.load({
                    verify: { projectID: "6811dc1ab820d525c9f70827" },
                    url: "https://general-runtime.voiceflow.com",
                    versionID: "production",
                    voice: {
                        url: "https://runtime-api.voiceflow.com",
                    },
                })
            }

            app.config.globalProperties.$chatbot = window.ChatbotClient
        }

        document.head.appendChild(script)
    },
}
